import classNames from 'classnames';
import React from 'react';

import Slides from 'common/components/RewindModal/Slides';

import styles from '../styles.module.scss';
import BottomActions from './component/BottomActions';

type Top3SeriesIntroProps = {
  onNext: () => void;
  isLastStep: boolean;
  flashbackType?: number;
};

const Top3SeriesIntro: React.FC<Top3SeriesIntroProps> = ({
  onNext,
  isLastStep,
  flashbackType
}) => {
  const title =
    flashbackType === 6 ? 'Top 3 séries Allociné' : 'Mon top séries';
  const subtitle =
    flashbackType === 6
      ? "Les 3 séries les mieux notées de l'année."
      : "Vos 3 séries les mieux notées de l'année.";

  return (
    <Slides>
      <div className={classNames(styles.contentLayout, styles.startLayout)}>
        <h2 className={styles.slideTitle}>{title}</h2>
        <h3 className={styles.slideText}>{subtitle}</h3>
      </div>
      <BottomActions
        showShare={false}
        showNext={!isLastStep}
        onNextClick={onNext}
      />
    </Slides>
  );
};

export default Top3SeriesIntro;
